import { render } from "./ArtivesNav.vue?vue&type=template&id=79bf096c&scoped=true"
import script from "./ArtivesNav.vue?vue&type=script&lang=js"
export * from "./ArtivesNav.vue?vue&type=script&lang=js"

import "./ArtivesNav.vue?vue&type=style&index=0&id=79bf096c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bf096c"]])

export default __exports__